export default "__VITE_ASSET__DJdj1y6n__"